import { useEffect } from 'react';
import { prop } from 'ramda';
import { useDispatch } from 'react-redux';
import { useAppSelector, useAuthSelector, useUserSelector } from 'js/store/hooks';

import * as actions from '../store/actions';
import { NEED_VERIFICATION_STATUSES } from '../constants';

export const useDataVerificationStatusPopup = () => {
    const dispatch = useDispatch();
    const isLoginInProcess = useAuthSelector(prop('isLoginInProcess'));
    const { ageVerificationStatus } = useUserSelector(prop('userDetails'));
    const enableDataVerificationStatusCheck = useAppSelector(prop('enableDataVerificationStatusCheck'));

    useEffect(() => {
        if (!ageVerificationStatus || !enableDataVerificationStatusCheck || isLoginInProcess) {
            return;
        }

        if (NEED_VERIFICATION_STATUSES.includes(ageVerificationStatus)) {
            dispatch(actions.showDataVerificationStatusPopupAction());
        }
    }, [dispatch, isLoginInProcess, ageVerificationStatus, enableDataVerificationStatusCheck]);
};
